import { EpisodeRibbonDataSource } from './EpisodeRibbonDataSource';
import { VodApi } from '../../api/VodApi';
import { DetailTranslationKeys, SettingsKeys } from '../../api/models/TranslationKeys';
import { CmsProperty } from '../../api/models/Shared.types';
import { Theme } from '../../config/theme';
import { CmsTabbedRibbon } from '../../components/cms/CmsTabbedRibbon';
import { Backend } from '../../api/Backend';
import { CardSizeInfo } from './CardSizeInfo';
import { TabbedDs } from './TabbedEpgEpisodesRibbonDataSource';
import { IAssetV5 } from '../../api/models/AndromeTV.types';

export class TabbedEpisodeRibbonDataSource {
  private assetId: string;
  private title: string;
  private seasonRibbons: TabbedDs[] = [];
  private readonly buttonHeight: number;
  private sizeInfo: CardSizeInfo | undefined;
  private readonly backend: Backend;

  constructor(backend: Backend, assetId: string, title: string, buttonHeight = 58) {
    this.backend = backend;
    this.assetId = assetId;
    this.title = title;
    this.buttonHeight = buttonHeight;

    this.sizeInfo = undefined;
  }

  load() {
    const seasons = this._getSeasonDataSources();

    return seasons.then(seasons => {
      seasons = seasons || [];
      this.seasonRibbons = [];
      if (seasons.length > 0) {
        let properties = this.backend.globalSettings.stringArray(SettingsKeys.propertiesVodDetailEpisodesRibbon);
        properties = properties
          ? properties
          : [CmsProperty.ShowProgress, CmsProperty.ShowEpisodeInfo, CmsProperty.HideInfo];
        this.seasonRibbons = seasons.map(season => {
          return {
            dataSource: new EpisodeRibbonDataSource(this.backend, season.assetId, properties!),
            title: season.seasonNumber
              ? `${this.backend.translations.forKey(DetailTranslationKeys.detail_season)} ${season.seasonNumber}`
              : season.text.title,
          };
        });
        this.sizeInfo = new CardSizeInfo();
        return this.seasonRibbons;
      }
    });
  }

  _getSeasonDataSources(): Promise<IAssetV5[]> {
    return VodApi.assetSeasons(this.backend, this.assetId).then(seasons => {
      return seasons.sort((a: IAssetV5, b: IAssetV5) => (a.seasonNumber || 0) - (b.seasonNumber || 0));
    });
  }

  isEmpty(): boolean {
    return !this.seasonRibbons || this.seasonRibbons.length === 0;
  }

  noData(): boolean {
    return !this.seasonRibbons || this.seasonRibbons.length === 0;
  }

  totalHeight(): number {
    return Theme.Fonts.Ribbon.Title.lineHeight + this.buttonHeight + (this.sizeInfo ? this.sizeInfo.height : 0);
  }

  componentDescription() {
    return {
      focusable: true,
      type: CmsTabbedRibbon,
      data: this,
      h: this.totalHeight(),
    };
  }
}
